'use strict';

if (!customElements.get('ax-instagram-slider')) {
  customElements.define('ax-instagram-slider', class AxInstagramSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.swiper');
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (!window.Swiper) {
        console.warn('Swiper not found');
        return;
      }
      this.swiperInstance = new window.Swiper(this.slider, {
        slidesPerView: 2.2,
        spaceBetween: 12,
        grabCursor: true,
        breakpoints: {
          750: {
            enabled: false
          }
        }
      });
    }
  });
}
